import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretDoubleLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.5 8 8 11.5 6.5 13l-5-5 5-5L8 4.5z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m10.5 8 3.5 3.5-1.5 1.5-5-5 5-5L14 4.5z"
	})]
});
export default SvgCaretDoubleLeft;
